// Origine absolue de tous les appels /api/* de cette page.
//
// Historiquement cette page était TOUJOURS servie par le Pi, et un chemin
// relatif suffisait. Elle tourne aujourd'hui à trois endroits : servie par le
// Pi, servie par halofloor.com, et chargée depuis des fichiers locaux dans
// l'application Tizen du téléviseur.
//
// RÈGLE : une page servie en http(s) parle à SA PROPRE origine. C'est vrai du
// Pi comme du site en ligne, et ça supprime la classe de bogue qui vient de
// coder une adresse en dur — sur halofloor.com, le repli LAN faisait demander
// au visiteur l'autorisation d'accéder à son réseau local, et l'extraction de
// la palette échouait sans bruit.
//
// L'adresse du Pi ne sert plus que dans le seul cas où il n'y a pas d'origine
// utilisable : le chargement depuis des fichiers locaux sur le téléviseur.
// __PI_LAN__ est remplacé à la compilation (voir --define) ; les compilations
// qui ne le définissent pas gardent l'ancienne valeur.
const REPLI_LAN = typeof __PI_LAN__ !== 'undefined' ? __PI_LAN__ : 'http://192.168.1.171:3000';

function origineParDefaut() {
  if (typeof location === 'undefined') return REPLI_LAN;
  if (location.protocol === 'http:' || location.protocol === 'https:') return location.origin;
  return REPLI_LAN;
}

// Échappatoire conservée : une page peut fixer window.__PIRADIO_API_BASE avant
// le chargement du bundle pour viser explicitement un autre serveur.
export const API_BASE = (typeof window !== 'undefined' && window.__PIRADIO_API_BASE)
  || origineParDefaut();
